/**
 *
 *
 *
 *
 *
 */
export const random = () => Math.random();
/**
 *
 *
 *
 *
 *
 *
 *
 */
export const isObject = (val) => typeof val === "object" && val !== null;
/**
 *
 *
 *
 *
 *
 *
 */
export const asObjectOrDefault = (val, defaultValue) => isObject(val) ? val : defaultValue;
export function camelcasify(value) {
    const [[firstChar, ...firstRest], ...rest] = value.split(/[-_]/g);
    return firstChar
        .toLowerCase()
        .concat(...firstRest, ...rest.flatMap(([firstCharOfRest, ...restOfTheRest]) => [
        firstCharOfRest.toUpperCase(),
        ...restOfTheRest,
    ]));
}
